import { FaLocationDot } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { PiPhoneCallFill } from "react-icons/pi";
import CusMap from "../Map/CustomMap";

const ContactUs = () => {
  return (
    <div>
      <div className="bg-no-repeat  bg-AdviceBg font-[Inter] bg-cover relative mb-10">
        <div className="absolute inset-0 bg-[#000000CF] "></div>
        <div className="relative z-10">
          <div className=" transform px-6 p-20 sm:p-28 flex flex-col items-center gap-8 text-white text-center">
            <h2 className="font-bold  leading-[0.35] sm:leading-6 text-6xl ">
              Contact Us
            </h2>
          </div>
        </div>
      </div>
      <div className="flex flex-col-reverse sm:flex-row justify-between gap-16 p-8 mb-20">
        <div className="flex flex-col gap-10 w-full">
          <div className="flex sm:flex-row flex-col gap-3">
            <div className="flex">
              <div className="bg-[#004C97] rounded-full p-4 ">
                <FaLocationDot className="text-4xl text-white" />
              </div>
            </div>
            <div className="grid">
              <h2 className="font-[Roboto]">Find us</h2>
              <p className="font-semibold">
                No. 6 Jaijelaye Street, Ajangbadi, Ojo, Lagos, Nigeria.
              </p>
            </div>
          </div>
          <div className="flex sm:flex-row flex-col gap-3">
            <div className="flex">
              <div className="bg-[#004C97] rounded-full p-4 ">
                <MdEmail className="text-4xl text-white" />
              </div>
            </div>
            <div className="grid">
              <h2 className="font-[Roboto]">Send mail</h2>
              <p className="font-semibold">Maqrahaatultanzeel@gmail.com</p>
            </div>
          </div>
          <div className="flex sm:flex-row flex-col gap-3">
            <div className="flex">
              <div className="bg-[#004C97] rounded-full p-4 ">
                <PiPhoneCallFill className="text-4xl text-white" />
              </div>
            </div>
            <div className="grid">
              <h2 className="font-[Roboto]">Call us</h2>
              <p className="font-semibold">+234 815 378 3287</p>
            </div>
          </div>
        </div>
        <div className="w-full">
          <CusMap />
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
